import List from "@/components/list";
import Bus from "./Bus.js";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function handleDelete(vo) {
    Bus.$emit("deleteLecturer", vo.row);
  }
  function handleEdit(data) {
    router.push({
      path: "/lecturer/edit",
      query: {
        id: data.row.uuid
      }
    });
  }

  const Deal = ({ props: { vo } }) => {
    let item = vo.row;
    let dealConf = [
      [
        item.isRevise ? "icon-edit" : "icon-edit-disable",
        "编辑",
        item.isRevise ? () => handleEdit(vo) : () => {},
        "lecturer:update",
      ],
      [
        item.isRevise ? "icon-delete" : "icon-delete-disable",
        "删除",
        item.isRevise ? () => handleDelete(vo) : () => {},
        "lecturer:delete",
      ]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "​讲师姓名",
      prop: "lecturerName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "讲师ID",
      prop: "id",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "师资分类",
      prop: "categoryName",
      minWidth: "120"
    },
    {
      label: "讲师职务",
      prop: "lecturerPost",
      minWidth: "160",
      showOverflowTooltip: true
    },
    {
      label: "所属分院",
      prop: "topDeptName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
